// import { getQueryString } from 'common/utils/common';
import { mobileOS } from '@common/utils/env';
import { msLocalStorage } from '@common/utils/cache';

// channel与appKey映射关系，未配置默认相同（相同亦建议配置，方便汇总所有channel和appKey）
enum CHANNEL_APPKEY_ENUM {
  'mswechat' = 'MS_WeChat', // 马上金融微信公众号
  'wechat' = 'MS_WeChat', // 马上金融微信公众号
  'MS_WeChat_AYH' = 'MS_WeChat_AYH', // 顺逸花微信公众号
  'MS_WECHAT_ZXH' = 'MS_WECHAT_ZXH', // 职享花(顺逸花官方贷款平台)公众号
  'MS_WECHAT_AYHJD' = 'MS_WECHAT_AYHJD', // 顺逸花借贷公众号
  'newzy_wechat' = 'newzy_wechat', // 优逸花微信公众号
  'lhh_wechat' = 'newzy_wechat', // 优逸花微信公众号
  'lhhjd_wx' = 'newzyjd_wx', //马上金融优逸花借贷微信公众号
  'lhhzgjd_wx' = 'newzyzgjd_wx', //优逸花正规借贷平台微信公众号
  'ALIPAY-SW' = 'alipaysw', // 马上金融支付宝生活号
  'SYH-SW' = 'Alipaysw_AYH', // 顺逸花支付宝生活号
  'MSJQ_ALIPAY' = 'MSJQ_ALIPAY', // 马上借钱服务窗
  'AYHYX_ALIPAY' = 'AYHYX_ALIPAY', // 顺逸花借钱优选服务窗
  'newzy_alipay' = 'newzy_alipay', // 优逸花支付宝生活号
  'newzy_alijq' = 'newzy_alijq', // 马上金融优逸花借钱生活号
  'lhh_alipay' = 'newzy_alipay', // 优逸花支付宝生活号
  'lhh_alijq' = 'newzy_alijq', // 马上金融优逸花借钱生活号
  'newzy_xcx' = 'newzy_xcx', // 优逸花微信小程序
  'MS_XCX_AYH' = 'MS_XCX_AYH', // 顺逸花微信小程序
  'ayh_XCX_majia' = 'ayh_XCX_majia', // 顺逸花借钱贷款现金消费分期平台 （顺逸花小程序马甲号）
  'YMKD_XCX' = 'YMKD_XCX', // 马上金融微信小程序
  'msjr_XCX_majia' = 'msjr_XCX_majia', // 马上金融手机借款借钱贷款平台 （马上金融小程序马甲号）
  'MS_XCX_TF' = 'MS_XCX_TF', // 顺逸花官方平台
  'newzy_alixcx' = 'newzy_alixcx', // 优逸花支付宝小程序
  'ayh_alixcx' = 'ayh_alixcx', // 顺逸花极速借钱支付宝小程序
  'ayh_jsxcx' = 'ayh_jsxcx', // 信用借钱极速版支付宝小程序
  'ayh_dyxcx' = 'ayh_dyxcx', // 顺逸花抖音小程序
  'MS_KYY_AYH' = 'MS_KYY_AYH', // 快应用
  'syhdl' = 'syhdl', // 顺逸花导流
  'SYH-DL' = 'syhdl', // 顺逸花导流
  'SXH5_dxz02' = 'SXH5_dxz02', // 顺逸花投放（SYH-APP） 马上金融投放（MSJR-APP）
  'newzy_tf' = 'newzy_tf', // 小马花花投放
  'wechat_mjh307' = 'wechat_mjh307',
  'wechat_mjh308' = 'wechat_mjh308',
  'wechat_mjh309' = 'wechat_mjh309',
  'wechat_mjh310' = 'wechat_mjh310',
  'wechat_mjh311' = 'wechat_mjh311',
  'WeChat_mjh323' = 'WeChat_mjh323',
  'WeChat_mjh324' = 'WeChat_mjh324',
  'WeChat_mjh325' = 'WeChat_mjh325',
  'WeChat_mjh326' = 'WeChat_mjh326',
  'WeChat_mjh352' = 'WeChat_mjh352',
  'WeChat_mjh353' = 'WeChat_mjh353',
  'WeChat_mjh354' = 'WeChat_mjh354',
  'WeChat_mjh355' = 'WeChat_mjh355',
  'WeChat_mjh356' = 'WeChat_mjh356',
  'WeChat_mjh357' = 'WeChat_mjh357',
  'WeChat_mjh358' = 'WeChat_mjh358',
  'WeChat_mjh359' = 'WeChat_mjh359',
  'WeChat_mjh360' = 'WeChat_mjh360',
  'WeChat_mjh361' = 'WeChat_mjh361',
  'WeChat_mjh362' = 'WeChat_mjh362',
  'WeChat_mjh363' = 'WeChat_mjh363',
  'WeChat_mjh364' = 'WeChat_mjh364',
  'WeChat_mjh365' = 'WeChat_mjh365',
  'WeChat_mjh366' = 'WeChat_mjh366',
  'WeChat_mjh367' = 'WeChat_mjh367',
  'WeChat_mjh368' = 'WeChat_mjh368',
  'WeChat_mjh369' = 'WeChat_mjh369',
  'WeChat_mjh370' = 'WeChat_mjh370',
  'WeChat_mjh371' = 'WeChat_mjh371',
  'WeChat_mjh372' = 'WeChat_mjh372',
  'WeChat_mjh373' = 'WeChat_mjh373',
}

// appKey根据channel和系统区分(APP端)
enum CHANNEL_OS_APPKEY_ENUM {
  'AYH-APP' = 'SYH_',
  'SYH-APP' = 'SYH_', // 顺逸花APP
  'AYHLITE-APP' = 'SYH_LITE_', // 顺逸花极速版APP
  'msjrapp' = 'MS_', // 马上金融APP
  'MSJR-APP' = 'MS_', // 马上金融APP
  'MSJRLITE-APP' = 'MS_LITE_', // 马上金融极速版APP
  'LHH-APP' = 'newzy_', // 小马花花APP
  'LHHLITE-APP' = 'newzy_LITE_', // 小马花花极速版APP
}

/**
 * 根据channel获得appKey
 */
export default (channel = msLocalStorage.get('PUBLIC_CHANNEL') ?? '') => {
  // 首先检测是否在APP环境
  if (CHANNEL_OS_APPKEY_ENUM[channel]) {
    return CHANNEL_OS_APPKEY_ENUM[channel] + mobileOS;
  }

  // 其次检测H5环境
  if (CHANNEL_APPKEY_ENUM[channel]) {
    return CHANNEL_APPKEY_ENUM[channel];
  }

  // 都没有则返回channel
  return channel;
};
